import {
  DownCircleFilled,
  PlusOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Row, Button, Dropdown, message } from "antd";
import React, { useEffect, useState } from "react";
import TableComponent from "../components/table/TableComponent";
import PageHeader from "../components/generic/PageHeader";
import "../styles/db.css";
import "../styles/task-library.css";
import "../styles/libraryTable.css";
import TaskModal from "./task/TaskModal";
import { getAllSuiteData } from "../service/suite.service";
import { task_column } from "../constants/Table Columns";
import { getAllTasks, getTaskByIdAndType } from "../service/task.service";
import TaskViewModal from "./task/TaskViewModal";
import ColumnToggle from "../components/generic/ColumnToggle";
import { useColumnToggle } from "../helper/useColumnToggle";

/** Columns the user can show/hide via the Columns control */
const OPTIONAL_TASK_COLUMNS = ["label", "createdBy", "createdDate", "comments"];

function Task() {
  const [isOpen, setIsOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [taskViewData, setTaskViewData] = useState({});
  const [testSuiteDetails, setTestSuiteDetails] = useState([]);
  const [allTaskData, setAllTaskData] = useState([]);
  const [allTaskName, setAllTaskName] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    getAllTasks()
      .then((res) => {
        setAllTaskData(res.data);
        let names = res.data.map((item) => item.taskName);
        setAllTaskName(names);
      })
      .catch((err) => {
        console.log("Something went wrong!");
      })
      .finally(() => {
        setTableLoading(false);
      });
    getAllSuiteData().then((res) => {
      setTestSuiteDetails(res.data);
    });
  }, []);

  const openModal = () => {
    setIsOpen(!isOpen);
  };
  const refreshTaskData = () => {
    getAllTasks().then((res) => {
      setAllTaskData(res.data);
    });
  };
  const fetchTestSuiteDetails = () => {
    openModal();
  };

  const handleViewOpen = () => {
    setIsViewOpen(!isViewOpen);
  };

  const handleViewClick = (record) => {
    getTaskByIdAndType(record.taskId, record.taskCategory)
      .then((response) => {
        setTaskViewData(response.data);
        handleViewOpen();
      })
      .catch(() => {
        message.error("Something went wrong! Please try again later");
      });
  };

  const processedColumns = task_column.map((col) => {
    if (col.key === "options") {
      return {
        ...col,
        render: (_, record) => (
          <Dropdown
            menu={{
              items: [
                { key: "1", label: "Run Task" },
                {
                  key: "2",
                  label: "View",
                  onClick: () => handleViewClick(record),
                },
              ],
            }}
            overlayClassName="table-row-actions-dropdown"
          >
            <button type="button" className="table-more-options">
              Options <DownCircleFilled />
            </button>
          </Dropdown>
        ),
      };
    }
    return col;
  });

  const { visibleColumns, columnToggleProps } = useColumnToggle(
    processedColumns,
    OPTIONAL_TASK_COLUMNS,
    "arc_cols_task",
  );

  return (
    <div className="db-container">
      <PageHeader
        icon={<ProfileOutlined />}
        title="Task Library"
        tooltip="Manage and create task"
        actions={
          <>
            <Button className="db-add">Create Label</Button>
            <Button
              className="db-add"
              icon={<PlusOutlined />}
              onClick={fetchTestSuiteDetails}
            >
              New Task
            </Button>
            <ColumnToggle {...columnToggleProps} />
          </>
        }
      />
      <Row className="table-container">
        <TableComponent
          wrapClassName="arc-library-table"
          columns={visibleColumns}
          data={allTaskData}
          pageSize="20"
          loading={tableLoading}
        />
      </Row>

      <TaskModal
        openModal={openModal}
        isOpen={isOpen}
        isNew={true}
        suiteData={testSuiteDetails}
        taskNames={allTaskName}
        refreshTaskData={refreshTaskData}
        onTaskCreated={() => {}}
      />
      <TaskViewModal
        isOpen={isViewOpen}
        handleModal={handleViewOpen}
        data={taskViewData}
      />
    </div>
  );
}

export default Task;
